import { Pipe, PipeTransform } from '@angular/core';
import { UNIT_MEASURE_TYPE_OPTIONS } from '~core/constants/unit-measure-type.constants';
import { UnitMeasureType } from '~core/models/core.models';

@Pipe({
  name: 'unitMeasureType',
  standalone: true
})
export class UnitMeasureTypePipe implements PipeTransform {
  transform(unit: UnitMeasureType | string | undefined | null): string {
    return UNIT_MEASURE_TYPE_OPTIONS[unit as UnitMeasureType] || unit || '';
  }
}
